import * as React from 'react';
import '../app.css';

export const PasswordPolicy = () => {
  return (
    <div>
      <div className="form-label fw-bold mb-2" style={{fontSize: '1rem', fontWeight: 'bold', marginLeft: '1.2rem'}}>Password Rules</div>
      <ul className="password-policy">
        <li>Minimum of 8 characters</li>
        <li>At least one lowercase letter</li>
        <li>At least one uppercase letter</li>
        <li>At least one special character</li>
        <li>At least one numeric character</li>
      </ul>
    </div>
  );
}